import React, { useState, useEffect, useRef } from "react";
import "./styles.css";
import Robot from "../../images/robot.png";
import SendImg from "../../images/Send.svg";
import { marked, parse } from "marked";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import PlayAudio from '../../images/Animation.gif'
import LoadingGif from '../../images/Animation2.gif'
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import QuizModal from "../QuizModal/QuizModal";
import remarkGfm from "remark-gfm";
import Warning from "../Warning/Warning"
import { API } from "../../constants";


const TextRenderer = ({ text, className, children }) => {
    // const formattedText = text.replace(/\n/g, '\n');
    // const formattedText = text || ""
    const cleanedText = text
        ?.split(/(?=\b[a-d]\))/i)
        .map((part) => part.trim())
        .join('\n\n');

    return (
        <div className={className}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{cleanedText}</ReactMarkdown>
            {children}
        </div>
    );
};

const




    Chat = ({ socket = "nazorat_test", textOfVideo, courseLanguage }) => {
        // console.log("bu text", textOfVideo)
        const location = useLocation()
        const testLanguage = location.state?.courseLanguage;

        const initialSocketUrl = `wss://talimbot.soof.uz/chatbot/${socket}?language=${testLanguage}`;
        const [socketUrl, setSocketUrl] = useState(initialSocketUrl);
        const [messages, setMessages] = useState([]);
        const [active, setActive] = useState(false);
        const [input, setInput] = useState("");
        const [isTyping, setIsTyping] = useState(false);
        const [clicked, setClicked] = useState(false);
        const [isSent21, setIsSent21] = useState(false);
        const [textForResult, setTextForResult] = useState(null);
        const [myAnswersList, setMyAnswersList] = useState([]);
        const [messagesCount, setMessagesCount] = useState(null);
        const [isSentResultMessage, setIsSentResultMessage] = useState(false);
        const [isRecording, setIsRecording] = useState(false)
        const navigate = useNavigate();
        const { t } = useTranslation()
        let [sectionBScores, setSectionBScores] = useState([]);
        const [feedbackMessages, setFeedbackMessages] = useState([]);
        const [testScore, setTestScore] = useState(0);
        const [sectionBAnswers, setSectionBAnswers] = useState([]);
        const inputRef = useRef(null);
        const [questionsBot, setQuestionsBot] = useState(false)



        const [isTestMode, setIsTestMode] = useState(
            socket === "nazorat_test" || socket === "nazorat_savol"
        );

        const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl);
        const chatBodyRef = useRef(null);

        useEffect(() => {
            const storedMessages =
                JSON.parse(localStorage.getItem("chatMessages")) || [];
            setMessages(storedMessages);
        }, []);

        const conditionToStartTestSavol = (messages[messages?.length - 1]?.text?.includes("Correct Answers") && messages[messages.length - 1]?.text?.includes("Incorrect Answers")) ||
            (messages[messages.length - 1]?.text?.includes("ответили") && messages[messages?.length - 1]?.text?.includes("правильно") && messages[messages.length - 1]?.text?.includes("ответы") && messages[messages.length - 1]?.text?.includes("вопросов"));

        const lastMessageIdentifier = messages[messages.length - 1];

        const isOptionalTestsOver = lastMessageIdentifier?.text?.includes("Test tugadi") ||
            // lastMessageIdentifier?.text?.includes("You have completed") ||
            // lastMessageIdentifier?.text?.includes("I have completed") ||
            // lastMessageIdentifier?.text?.includes("Thank you for") ||
            // lastMessageIdentifier?.text?.includes("Test 1 is complete") ||
            // lastMessageIdentifier?.text?.includes("Your test is completed") ||
            // lastMessageIdentifier?.text?.includes("The test") ||
            // lastMessageIdentifier?.text?.includes("answers or further assistance") ||
            // lastMessageIdentifier?.text?.includes("You've completed") ||
            // // lastMessageIdentifier?.text?.includes("Raxmat") ||
            // // lastMessageIdentifier?.text?.includes("Raxmat!") ||
            // // lastMessageIdentifier?.text?.includes("Rahmat! Testlarni tugatdingiz") ||
            lastMessageIdentifier?.text?.includes("Correct answer") ||
            lastMessageIdentifier?.text?.includes("To'g'ri javoblar:") ||
            lastMessageIdentifier?.text?.includes("To'g'ri javoblar") ||
            lastMessageIdentifier?.text?.includes("correct answers") ||
            lastMessageIdentifier?.text?.includes("Корректные ответ") ||
            lastMessageIdentifier?.text?.includes("Correct answer:")
        // // lastMessageIdentifier?.text?.includes("raxmat!") ||
        // lastMessageIdentifier?.text?.includes("Rahmat, testlarni tugatdingiz!") ||
        // lastMessageIdentifier?.text?.includes("barcha javoblaringizni tekshirdik") ||
        // lastMessageIdentifier?.text?.includes("Testni tugatdingiz") ||
        // lastMessageIdentifier?.text?.includes("javoblaringizni tekshirish") ||
        // lastMessageIdentifier?.text?.includes("end of the test") ||
        // lastMessageIdentifier?.text?.includes("If you would like to") ||
        // lastMessageIdentifier?.text?.includes("sizga javoblaringiz haqida ma'lumot") ||
        // lastMessageIdentifier?.text?.includes("Rahmat! Savollarga javob ") ||
        // lastMessageIdentifier?.text?.includes("javoblar sonini so'rang") ||
        // lastMessageIdentifier?.text?.includes("Siz barcha") ||
        // lastMessageIdentifier?.text?.includes("Спасибо") ||
        // lastMessageIdentifier?.text?.includes("Тесты завершены") ||
        // lastMessageIdentifier?.text?.includes("завершены") ||
        // lastMessageIdentifier?.text?.includes("Тест завершен") ||
        // lastMessageIdentifier?.text?.includes("Тестирование завершено") ||
        // lastMessageIdentifier?.text?.includes("завершено") ||
        // lastMessageIdentifier?.text?.includes("Вы завершили") ||
        // lastMessageIdentifier?.text?.includes("Тесты закончены") ||
        // lastMessageIdentifier?.text?.includes("завершили")
        console.log(JSON.stringify(lastMessageIdentifier?.text));

        const isAllTestsOver = (
            (lastMessageIdentifier?.text?.includes("Problem 1") && lastMessageIdentifier?.text?.includes("Problem 2"))
            && (lastMessageIdentifier?.text?.includes("Evaluation of Your Answer")
                || lastMessageIdentifier?.text?.includes("answered both")
                || lastMessageIdentifier?.text?.includes("both problems")
                || lastMessageIdentifier?.text?.includes("Final Evaluation")
            ))
            && messages?.length > 20;



        const isSectionB = messages?.length > 30 &&
            (lastMessageIdentifier?.text?.includes("SECTION B") ||
                lastMessageIdentifier?.text?.includes("Section B") ||
                lastMessageIdentifier?.text?.includes("B BO‘LIMI") ||
                lastMessageIdentifier?.text?.includes("B bo‘limi") ||
                lastMessageIdentifier?.text?.includes("Masala") ||
                lastMessageIdentifier?.text?.includes("Quyidagi") ||
                lastMessageIdentifier?.text?.includes("РАЗДЕЛ B") ||
                lastMessageIdentifier?.text?.includes("Раздел B") ||
                lastMessageIdentifier?.text?.includes("Задача Раздела B") ||
                lastMessageIdentifier?.text?.includes("Задача раздела B") ||
                lastMessageIdentifier?.text?.includes("Задача") ||
                lastMessageIdentifier?.text?.includes(" Раздела B"));

        const isProblemsStarterMessage = (lastMessageIdentifier?.text?.includes("Correct answer") &&
            lastMessageIdentifier?.text?.includes("My answer")) ||
            (lastMessageIdentifier?.text?.includes("Правильные ответы") &&
                lastMessageIdentifier?.text?.includes("Мои ответы"));

        const isTwentythQuestion = messages[messages.length - 1]?.text?.includes("Question 20") || messages[messages.length - 1]?.text?.includes("Question-20") || messages[messages.length - 1]?.text?.includes("20 Question") || messages[messages.length - 1]?.text?.includes("Test 20") || messages[messages.length - 1]?.text?.includes("Test 20.");

        const isResult = messages[messages.length - 1]?.text?.includes("Correct Answer") && messages[messages.length - 1]?.text?.includes("My answer");
        const isTwentyFirstMessage = (messages[messages.length - 1]?.text?.includes("Thank you") && (messages[messages.length - 1]?.text?.includes("the answers") || messages[messages.length - 1]?.text?.includes("your answers")) && (messages[messages.length - 1]?.text?.includes("questions incorrectly") || messages[messages.length - 1]?.text?.includes("feel free to ask") || messages[messages.length - 1]?.text?.includes("let me know"))) || (messages[messages.length - 1]?.text?.includes("Спасибо за") && (messages[messages.length - 1]?.text?.includes("все вопросы") || messages[messages.length - 1]?.text?.includes("your answers")) && (messages[messages.length - 1]?.text?.includes("questions incorrectly") || messages[messages.length - 1]?.text?.includes("feel free to ask") || messages[messages.length - 1]?.text?.includes("дайте мне знать")));


        useEffect(() => {
            if (isSectionB) {
                setMessagesCount(messages?.length);
            }
        }, [isSectionB])

        useEffect(() => {
            if (isSentResultMessage) {
                setMessages((prev) => {
                    return prev?.map((item, index) => {
                        if (index === messages?.length - 1) {
                            return { ...item, visible: true }
                        }

                        return item;
                    })
                });
            }
        }, [isSentResultMessage])

        useEffect(() => {
            if (!!messagesCount && messages?.length === (messagesCount + 1)) {
                const dateTime = Date.now();
                const newMessage = {
                    sender: 'user',
                    text: "Preparing your result...",
                    visible: true,
                    time: new Date(dateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    dateTime,
                };
                setMessages([...messages, newMessage]);

                let resultMessage = "";

                if (testLanguage === "ru") {
                    resultMessage = `
                    Пожалуйста, оцените количество баллов, которые я получил на основе моих ответов на вопросы a, b, c, и вычислите мой общий балл.

Формат:
Баллы a: (мой балл)/20
b: (мой балл)/20
c: (мой балл)/20
Итого: (мой балл)/60
                `;
                };
                if (testLanguage === "uz") {
                    resultMessage = `Iltimos, a, b, c savollarga bergan javoblarim asosida nechta ball olganimni baholang va umumiy ballimni hisoblang.
Format: Ball a:(mening ballim)/20 b:(mening ballim)/20 c:(mening ballim)/20
Jami: (mening ballim)/60`
                };

                if (testLanguage === "en") {
                    resultMessage = `Please evaluate the number of points I received based on my answers to the a, b, c questions and calculate my total score.

Format:
Ball a: (my score)/20
b: (my score)/20
c: (my score)/20
Total: (my score)/60`
                }


                sendMessage(resultMessage);
                setIsSentResultMessage(true);
            }
        }, [messages, messagesCount, testLanguage]);

        useEffect(() => {
            if (isSentResultMessage) {
                const lastBotMessage = messages[messages.length - 1]?.text;
                const totalScoreMatch = testLanguage === "ru"
                    ? lastBotMessage?.match(/Итого:\s*(\d+)\/\d+/i)
                    : testLanguage === "uz"
                        ? lastBotMessage?.match(/jami:\s*(\d+)\/\d+/i)
                        : lastBotMessage?.match(/total:\s*(\d+)\/\d+/i);

                if (totalScoreMatch && totalScoreMatch[1]) {
                    const totalScore = parseInt(totalScoreMatch[1], 10);
                    setSectionBScores((prevScores) => [...prevScores, { score: totalScore }]);
                }
            }
        }, [isSentResultMessage, messages]);

        useEffect(() => {
            //         const text = `Correct answer: a,b,a,c,c,b,c,a,c,a,b,a,c,b,c,a,c,c,b,b
            // My answer: a,b,d,a,c,b,d,a,d,b,d,a,b,c,a,c,c,b,b,d,a`;
            //
            //         text.split("\n")?.map((t) => {
            //             console.log(t?.split(":")[1]);
            //         });

            if (isProblemsStarterMessage) {
                messages[messages.length - 1]?.text?.split("\n")?.map((t) => {
                    t?.split(":")[1]?.split(",")?.map(letter => {
                        console.log(letter?.trim());
                    })
                });
            }
        }, [isProblemsStarterMessage]);

        useEffect(() => {
            if (isAllTestsOver) {
                const pointsOfFirstQuestion = messages[messages.length - 1]?.text?.split("Problem 1")[1]?.match(/\d+\/\d+/)[0]?.split('/')?.[0];
                const pointsOfSecondQuestion = messages[messages.length - 1]?.text?.split("Problem 2")[1]?.match(/\d+\/\d+/)[0]?.split('/')?.[0];

                localStorage.setItem("scores", `${pointsOfFirstQuestion}/${pointsOfSecondQuestion}`);

                navigate('/student/courses/quiz/results');
            }
        }, [isAllTestsOver]);

        useEffect(() => {
            if (conditionToStartTestSavol || isProblemsStarterMessage) {
                setSocketUrl(`wss://talimbot.soof.uz/chatbot/nazorat_savol?language=${testLanguage}`);
                setIsTestMode(true);
            }
        }, [messages, conditionToStartTestSavol, isProblemsStarterMessage]);

        // textOfVideo = socket === "nazorat_savol" ? `Based on this information, you must create one problem for me for the type of question SECTION B.
        //     The SECTION B problem should meet the following requirements, similar to the sample problem.
        //     Requirements: "Section B (30 points):
        //         o Consists of three tasks (a, b, c) based on a complex audit situation
        //         o A question may include several sub-questions covering various aspects of the audit
        //         o Candidates must demonstrate the ability to apply knowledge and skills to analyze the situation, identify risks, and develop audit procedures."
        //     You do not need to give me any feedback on whether I answered the question correctly or incorrectly after I have answered it. You should tell me after I have asked it.
        //     You will not ask questions that are unrelated to this information and you will not answer any of my questions.
        //     Your main task is to give me the problem and get my answer.` : textOfVideo;

        useEffect(() => {
            if (socket === "nazorat_savol") {
                if (testLanguage === "ru") {
                    textOfVideo = `
                На основе следующей информации составьте для меня вопрос РАЗДЕЛ B.

Вопрос РАЗДЕЛ B должен соответствовать следующим требованиям:

Требования: "Раздел B (60 баллов):

Должен состоять из трёх заданий (a, b, c), основанных на сложной ситуации, условии или процессе, каждое задание оценивается в 20 баллов (a-20 баллов, b-20 баллов, c-20 баллов, всего 60 баллов). Каждое задание может включать несколько подзадач и должно охватывать различные аспекты предмета или темы. Кандидаты должны проанализировать данную ситуацию, выявить проблемы, применить соответствующие знания и навыки и продемонстрировать способность делать научно обоснованные или логически выверенные выводы."

После того как я отвечу на вопрос, вы просто напишите слово "спасибо". Вы не будете давать никаких комментариев по поводу того, правильно ли я ответил или нет. Своё мнение вы выскажете только по моему запросу.

Вы не будете задавать вопросы, не относящиеся к данной информации, и не будете отвечать на мои вопросы. Ваша основная задача — дать мне задачу (вопрос), получить мой ответ и, когда я попрошу, сообщить мою оценку и правильные ответы.
            `;
                }
                if (testLanguage === "en") {
                    textOfVideo = `
               Based on the following information, create a question of SECTION B for me.

The SECTION B question must meet the following requirements:

Requirements: "Section B (60 points):

It should consist of three tasks (a, b, c) based on a complex situation, condition, or process, with each task worth 20 points (a-20 points, b-20 points, c-20 points, total 60 points). Each task may include several sub-questions and should cover various aspects of the subject or topic. Candidates must analyze the given situation, identify problems, apply relevant knowledge and skills, and demonstrate the ability to draw scientifically grounded or logically sound conclusions."

After I answer the question, you will only reply with the word "thank you". You will not make any comments about whether I answered correctly or incorrectly. You will only provide your opinion when I ask.

You will not ask questions unrelated to this information and will not answer any of my questions. Your main task is to give me the case (question), receive my answer, and when I request it, tell me my score and the correct answers.
            `;
                };
                if (testLanguage === "uz") {
                    textOfVideo = `
                Quyidagi ma’lumotlarga asoslanib, menga B BO‘LIMI turidagi savolga mos bitta masala (muammo) yarating.

B BO‘LIMI savoli quyidagi talablarni qanoatlantirishi kerak:

Talablar: "B bo‘limi (60 ball):

Murakkab holat, vaziyat yoki jarayonga asoslangan uchta topshiriq (a, b, c) dan iborat bo‘lsin, har bir topshiriqqa 20 ball( a-20 ball, b-20 ball, c-20 ball , umumiy 60 ball) ajratilsin. Har bir topshiriq bir necha kichik savollarni o‘z ichiga olishi mumkin, va fan yoki mavzuning turli jihatlarini qamrab olishi kerak. Nomzodlar berilgan holatni tahlil qilish, muammolarni aniqlash va tegishli bilim va ko‘nikmalarini qo‘llab, ilmiy asoslangan yoki mantiqiy xulosa chiqarish qobiliyatini namoyon etishlari lozim."

Men savolga javob berganimdan keyin menga faqat "raxmat" so'zini yuborasiz. to‘g‘ri yoki noto‘g‘ri javob berganim haqida menga hech qanday fikr bildirmaysiz. Buni men so‘raganimdan keyin aytasiz.

Siz ushbu ma’lumotlarga aloqasi bo‘lmagan savollarni bermaysiz va mening hech bir savolimga javob bermaysiz. Sizning asosiy vazifangiz – menga masalani (savolni) berish, javobimni olish va men so'raganimdan so'ng mening balim va togri javoblarni aytishdir.`
                }
            } else {
                textOfVideo = textOfVideo;
            }
        }, [socket, testLanguage])

        // console.log("textOfVideo", textOfVideo);

        if (isOptionalTestsOver && !isSent21) {
            const correctAnswers = "a,b,a,d,...";
            const myAnswers = myAnswersList.join(",");

            if (testLanguage === "ru") {
                sendMessage(`
                Отправь мне ответы на 20 тестов в следующем формате, без лишних деталей.
                Правильные ответы: (${correctAnswers})
                Мои ответы: (${myAnswers})
            `);

            } else {
                sendMessage(`
                Send me the 20 tests answers in the following format, without any extra details.
                Correct answer: (${correctAnswers})
                My answer: (${myAnswers});;
            `);
            }
            setIsSent21(true);
        }

        const formatDate = () => {
            const date = new Date();
            const day = date.getDate();
            const months = [
                "yanvar",
                "fevral",
                "mart",
                "aprel",
                "may",
                "iyun",
                "iyul",
                "avgust",
                "sentyabr",
                "oktyabr",
                "noyabr",
                "dekabr",
            ];
            return `${day} ${months[date.getMonth()]} ${date.getFullYear()}`;
        };

        const handleSend = () => {
            if (socket === "help") {
                setQuestionsBot(true)
            }
            if (messages?.length === messagesCount) {
                if (messages[messages?.length - 1]?.text <= input?.length) {
                    toast.warning("Your answer should be longer!");
                    return;
                }
            }

            if (input.trim()) {
                const dateTime = Date.now();
                const newMessage = {
                    sender: 'user',
                    text: input,
                    visible: true,
                    time: new Date(dateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    dateTime,
                };

                if (["a", "b", "c", "d", "A", "B", "C", "D"].includes(input.trim())) {
                    setMyAnswersList((prev) => [...prev, input.trim()]);
                }

                if (isSectionB) {
                    setSectionBAnswers((prevAnswers) => [...prevAnswers, input.trim()]);
                }

                setActive(true);
                setMessages((prev) => {
                    if (prev[messages?.length - 1]?.text !== "Preparing your result...") {
                        return [...prev, newMessage]
                    }

                    return [...prev, { ...newMessage, visible: false }];
                });
                if (isTwentyFirstMessage) {
                    const myAnswers = myAnswersList.join(",");
                    sendMessage(`
                            Send me the 20 tests answers in the following format. without any extra details.
                            Correct answer :(all Correct answer latters (example:a,b,a,d...))
                            My answer :(${myAnswers})
                       `);
                } else {
                    sendMessage(`${input}`);
                }

                setInput('');
                setIsTyping(true);
                inputRef.current?.focus();
            }
        };

        const [tests, setTests] = useState([]);

        const handleStartTest = () => {
            setClicked(true);
            if (messages.length > 20) {
                if (testLanguage === "ru") {
                    sendMessage(`
                  На основе следующей информации составьте для меня вопрос РАЗДЕЛ B.

Вопрос РАЗДЕЛ B должен соответствовать следующим требованиям:

Требования: "Раздел B (60 баллов):

Должен состоять из трёх заданий (a, b, c), основанных на сложной ситуации, условии или процессе, каждое задание оценивается в 20 баллов (a-20 баллов, b-20 баллов, c-20 баллов, всего 60 баллов). Каждое задание может включать несколько подзадач и должно охватывать различные аспекты предмета или темы. Кандидаты должны проанализировать данную ситуацию, выявить проблемы, применить соответствующие знания и навыки и продемонстрировать способность делать научно обоснованные или логически выверенные выводы."

После того как я отвечу на вопрос, вы просто напишите слово "спасибо". Вы не будете давать никаких комментариев по поводу того, правильно ли я ответил или нет. Своё мнение вы выскажете только по моему запросу.

Вы не будете задавать вопросы, не относящиеся к данной информации, и не будете отвечать на мои вопросы. Ваша основная задача — дать мне задачу (вопрос), получить мой ответ и, когда я попрошу, сообщить мою оценку и правильные ответы.
                `);
                    setIsTestMode(false);
                } if (testLanguage === "en") {
                    sendMessage(`
                   Based on the following information, create a question of SECTION B for me.

The SECTION B question must meet the following requirements:

Requirements: "Section B (60 points):

It should consist of three tasks (a, b, c) based on a complex situation, condition, or process, with each task worth 20 points (a-20 points, b-20 points, c-20 points, total 60 points). Each task may include several sub-questions and should cover various aspects of the subject or topic. Candidates must analyze the given situation, identify problems, apply relevant knowledge and skills, and demonstrate the ability to draw scientifically grounded or logically sound conclusions."

After I answer the question, you will only reply with the word "thank you". You will not make any comments about whether I answered correctly or incorrectly. You will only provide your opinion when I ask.

You will not ask questions unrelated to this information and will not answer any of my questions. Your main task is to give me the case (question), receive my answer, and when I request it, tell me my score and the correct answers.
                `);
                    setIsTestMode(false);
                };
                if (testLanguage === "uz") {
                    sendMessage(`
                Quyidagi ma’lumotlarga asoslanib, menga B BO‘LIMI turidagi savolga mos bitta masala (muammo) yarating.

B BO‘LIMI savoli quyidagi talablarni qanoatlantirishi kerak:

Talablar: "B bo‘limi (60 ball):

Murakkab holat, vaziyat yoki jarayonga asoslangan uchta topshiriq (a, b, c) dan iborat bo‘lsin, har bir topshiriqqa 20 ball( a-20 ball, b-20 ball, c-20 ball , umumiy 60 ball) ajratilsin. Har bir topshiriq bir necha kichik savollarni o‘z ichiga olishi mumkin, va fan yoki mavzuning turli jihatlarini qamrab olishi kerak. Nomzodlar berilgan holatni tahlil qilish, muammolarni aniqlash va tegishli bilim va ko‘nikmalarini qo‘llab, ilmiy asoslangan yoki mantiqiy xulosa chiqarish qobiliyatini namoyon etishlari lozim."

Men savolga javob berganimdan keyin menga faqat "raxmat" so'zini yuborasiz. to‘g‘ri yoki noto‘g‘ri javob berganim haqida menga hech qanday fikr bildirmaysiz. Buni men so‘raganimdan keyin aytasiz.

Siz ushbu ma’lumotlarga aloqasi bo‘lmagan savollarni bermaysiz va mening hech bir savolimga javob bermaysiz. Sizning asosiy vazifangiz – menga masalani (savolni) berish, javobimni olish va men so'raganimdan so'ng mening balim va togri javoblarni aytishdir.`)
                    setIsTestMode(false);
                }
                return;
            }
            sendMessage("Start test.");
            setIsTestMode(false);
            setActive(true);
        };


        const [sectionBMessages, setSectionBMessages] = useState([]);

        useEffect(() => {
            if (clicked && lastMessage?.data) {
                const botMessage = {
                    text: lastMessage.data,
                };
                setSectionBMessages((prevMessages) => [...prevMessages, botMessage]);
                setClicked(false);
            }
        }, [lastMessage, socket]);

        // console.log("section B messages", sectionBMessages);

        useEffect(() => {
            if (lastMessage?.data && socket === "nazorat_test") {
                const botMessage = lastMessage.data;
                setTests((prevTests) => [...prevTests, botMessage]);
            }
        }, [lastMessage]);
        const [sectioBQuestion, setSectionBQuestion] = useState([]);
        useEffect(() => {
            if (socket === "nazorat_savol") {
                if (lastMessage?.data) {
                    const botMessage = lastMessage.data;
                    setSectionBQuestion((prevTests) => [...prevTests, botMessage]);
                }
            }
        }, [lastMessage]);



        useEffect(() => {
            if (socket === "nazorat_test" && messages.length === 41) {
                sendMessage(`Please send me the correct answers for the 20 tests in the following format.
Format: correct answers:(a,b,c,.....)

For each of the 20 correct answers you have sent, please provide feedback in the following "feedbackformat".
feedbackformat:
1.feedback
2.feedback
...`)
            }
        }, [messages]);

        console.log(messages.length)

        useEffect(() => {
            if (lastMessage?.data && socket === "nazorat_test" && messages.length === 42) {
                const newMessage = lastMessage.data;

                setFeedbackMessages((prevMessages) => [...prevMessages, newMessage]);
            }
        }, [lastMessage, messages, socket]);

        // console.log("tests", tests);
        // console.log("bu feedbeklar", feedbackMessages);

        function replaceMyAnswers(text, answersArray) {
            const formattedAnswers = answersArray.join(", ");

            return text.replace(/My answer:\s*[a-z](?:,\s*[a-z])*/i, `My answer: ${formattedAnswers}`);
        };

        useEffect(() => {
            const ready = messages?.map((message) => {
                if (message.text.includes("Correct answer") && message.text.includes("My answer")) {
                    return {
                        ...message,
                        text: replaceMyAnswers(message.text, myAnswersList),
                    }
                }

                return message;
            });

            setMessages(ready);
        }, [(lastMessage?.data?.includes("Correct answer") && (lastMessage?.data?.includes("My answer")))]);

        useEffect(() => {
            if (active && lastMessage !== null) {
                const dateTime = Date.now();
                const botMessage = {
                    sender: "bot",
                    visible: true,
                    text: lastMessage.data,
                    time: new Date(dateTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    }),
                    dateTime,
                };

                setMessages((prev) => {
                    const messageExists = prev.some((msg) => msg.text === botMessage.text);

                    if (messageExists) return prev;

                    if (prev[prev.length - 1]?.text !== "Preparing your result...") {
                        return [...prev, botMessage];
                    }

                    return [...prev, { ...botMessage, visible: false }];
                });

                setIsTyping(false);
            }

            setClicked(false);
        }, [lastMessage]);



        useEffect(() => {
            if (chatBodyRef.current) {
                chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
            }
        }, [messages]);

        const reconnectWebSocket = () => {
            setSocketUrl("");
            setTimeout(() => setSocketUrl(initialSocketUrl), 100);
        };

        const isConnectionOpen = readyState === ReadyState.OPEN;

        const connectionStatus = {
            [ReadyState.CONNECTING]: "Connecting",
            [ReadyState.OPEN]: "Open",
            [ReadyState.CLOSING]: "Closing",
            [ReadyState.CLOSED]: "Closed",
            [ReadyState.UNINSTANTIATED]: "Uninstantiated",
        }[readyState];
        let templateOfAI = "";
        if (courseLanguage === "ru") {
            templateOfAI = `
        Вы — искусственный интеллект по имени Diyora.
Ваша задача — отвечать на вопросы студента только на русском языке.
Не отвечайте на других языках, основываясь на приведенной выше информации,
если студент не понимает тему.
Вам категорически запрещено предоставлять информацию, выходящую за рамки указанной выше.
    `
        } if (courseLanguage === "en") {
            templateOfAI = `
        You are an artificial intelligence named Diyora. 
        Your task is to answer the student's questions only in English, 
        do not answer any other language, based on the information above if 
        the student does not understand the topic. You are absolutely not allowed to provide information outside of 
        the information above.;
    `
        } if (courseLanguage === "uz") {
            templateOfAI = `Siz Diyora ismli sun'iy intellektsiz.
Sizning vazifangiz — faqat o'zbek tilida talabalar savollariga javob berish, boshqa hech qaysi tilda javob bermaslik.
Agar talaba mavzuni tushunmasa, faqat yuqorida berilgan ma'lumotlarga asoslanib javob bering.
Sizga yuqoridagi ma'lumotlardan tashqaridagi ma'lumotlarni taqdim etish mutlaqo taqiqlanadi.`
        }
        useEffect(() => {
            if (!!textOfVideo && isTestMode) {
                sendMessage(JSON.stringify(`${textOfVideo}`));
            }

            if (!!textOfVideo && socket === 'help') {
                sendMessage(JSON.stringify(`Information: ${textOfVideo}; Task: ${templateOfAI}`));
            }
        }, [connectionStatus === ReadyState.OPEN, textOfVideo]);

        const [audioBlob, setAudioBlob] = useState(null);
        const mediaRecorderRef = useRef(null);
        const audioChunksRef = useRef([]);
        const startRecording = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                const mediaRecorder = new MediaRecorder(stream);
                mediaRecorderRef.current = mediaRecorder;
                audioChunksRef.current = [];
                mediaRecorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        audioChunksRef.current.push(event.data);
                    }
                };
                mediaRecorder.onstop = () => {
                    const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
                    setAudioBlob(audioBlob);
                    sendRecord(audioBlob);
                };
                mediaRecorder.start();
                setIsRecording(true);
            } catch (error) {
                console.error("Ovoz yozib olishda xatolik:", error);
            }
        };
        const [audioText, setAudioText] = useState([])
        const sendRecord = (blob) => {
            const formData = new FormData();
            formData.append("file", blob);

            // console.log("audio blob", blob);

            axios.post("https://stt.soof.uz/stt", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "accept-language": courseLanguage,
                },
            }).then((response) => {
                setAudioText(response?.data);
            }).catch((err) => {
                console.log(err);
            });
        };
        const transcriptRef = useRef(audioText?.transcript);

        useEffect(() => {
            transcriptRef.current = audioText?.transcript;
        }, [audioText.transcript]);
        const handleStopAndSend = () => {
            if (mediaRecorderRef.current) {
                mediaRecorderRef.current.stop();
                setIsRecording(false);
            }
            setTimeout(() => {
                const latestTranscript = transcriptRef.current;
                if (latestTranscript && latestTranscript.trim()) {
                    const dateTime = Date.now();
                    const newMessage = {
                        sender: 'user',
                        text: latestTranscript,
                        visible: true,
                        time: new Date(dateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                        dateTime,
                    };
                    setActive(true);
                    setMessages((prev) => {
                        const lastMessage = prev[prev.length - 1];
                        if (lastMessage?.text !== "Preparing your result...") {
                            return [...prev, newMessage];
                        }
                        return [...prev, { ...newMessage, visible: false }];
                    });

                    if (!isTwentyFirstMessage) {
                        sendMessage(`${latestTranscript}`);
                    }

                    setIsTyping(true);
                }
            }, 1000);
        };

        const [textToVois, setTextToVois] = useState("");
        const [playState, setPlayState] = useState({});
        const [currentAudio, setCurrentAudio] = useState(null);
        const [abortController, setAbortController] = useState(null);
        const [audioFiles, setAudioFiles] = useState([]);
        const [audioIndex, setAudioIndex] = useState(1);


        const [correctAnswers, setCorrectAnswers] = useState([]);
        const [totalScore, setTotalScore] = useState(0);

        const calculateTotalScore = (correctAnswers, userAnswers, sectionBAnswers = []) => {
            let score = 0;

            correctAnswers.forEach((answer, index) => {
                if (answer.trim() == userAnswers[index]?.trim()) {
                    score += 2;
                }
            });

            sectionBAnswers.forEach((answer) => {
                score += answer.score || 0;
            });

            return score;
        };

        useEffect(() => {
            if (isProblemsStarterMessage) {
                const extractedAnswers = messages[messages.length - 1]?.text
                    ?.split("\n")
                    ?.find((line) =>
                        line.startsWith("Correct answer") ||
                        line.startsWith("Правильные ответы")
                    )
                    ?.split(":")[1]
                    ?.split(",")
                    ?.map((answer) => answer.trim());

                if (extractedAnswers) {
                    setCorrectAnswers(extractedAnswers);
                    setTestScore(totalScore)
                }
            }
        }, [isProblemsStarterMessage, messages]);


        useEffect(() => {
            if (correctAnswers.length > 0 || sectionBScores.length > 0) {
                const total = calculateTotalScore(correctAnswers, myAnswersList, sectionBScores);
                setTotalScore(total);
            }
        }, [correctAnswers, myAnswersList, sectionBScores]);

        const [quizModal, setQuizModal] = useState(false);


        // console.log("Total:", totalScore);

        useEffect(() => {
            if (messages.length > 0) {
                const lastMessage = messages[messages.length - 1];
                if (lastMessage.sender !== "user" && socket === "help") {
                    setTextToVois(lastMessage.text);
                }
            }
        }, [messages]);
        const [playWait, setPLayWait] = useState()
        const playText = (index) => {
            axios.post("https://tts.soof.uz/tts", {
                text: textToVois,
            }, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "accept-language": courseLanguage,
                },
                responseType: "arraybuffer",
            }).then((response) => {
                const audioBlob = new Blob([response.data], { type: "audio/wav" });
                const audioUrl = URL.createObjectURL(audioBlob);
                const audio = new Audio(audioUrl);


                setCurrentAudio(audio);

                setAudioFiles(prev => [...prev, { index: audioIndex, url: audioUrl }]);
                setAudioIndex(prev => prev + 2);

                console.log("audio list", audioFiles)
            }).catch((err) => {
                if (axios.isCancel(err)) {
                    console.log("Audio loading cancelled");
                } else {
                    console.log(err);
                }
            });
        };


        const playSavedAudio = (index) => {
            const audioFile = audioFiles.find(file => file.index === index);

            if (audioFile && audioFile.url) {
                console.log("Playing audio:", audioFile.url);
                if (currentAudio) {
                    currentAudio.pause();
                    currentAudio.currentTime = 0;
                }
                const audio = new Audio(audioFile.url);
                setCurrentAudio(audio);
                audio.play()
                    .then(() => {
                        console.log("Audio started playing");
                        setPlayState({ [index]: { isPlayVois: true } });
                    })
                    .catch(err => {
                        console.error("Audio playback error:", err);
                    });

                audio.onended = () => {
                    setCurrentAudio(null);
                    setPlayState({ [index]: { isPlayVois: false } });
                };
            } else {
                console.log("Audio file not found for index:", index);
            }
        };


        useEffect(() => {
            if (typeof textToVois === "string" && textToVois.trim() !== "") {
                playText(0);
            }
        }, [textToVois]);

        // useEffect(() => {
        //     if (lastMessageIdentifier?.text) {
        //         console.log("Oxirgi xabar:", lastMessageIdentifier.text);
        //     }
        // }, [lastMessageIdentifier]);
        const { enrollmentId, chapterId } = useParams();

        const first20Tests = tests.slice(1, 21)


        const parsedTests = first20Tests.map((test, index) => {
            let questionMatch = test.match(/\[(.*?)\]/);
            let question = questionMatch ? questionMatch[1] : null;

            if (!question) {
                questionMatch = test.match(/^(.*?)\s[a-d]\)/);
                question = questionMatch ? questionMatch[1].trim() : "No question found";
            }

            const optionsMatch = test.match(/a\)(.*)/);
            const options = optionsMatch ? optionsMatch[1].split(/\s[bcd]\)/).map(opt => opt.trim()) : [];

            const userOption = myAnswersList[index];
            const correctOption = correctAnswers[index];
            const answerIndex = userOption ? userOption.charCodeAt(0) - 97 : -1;
            const answer = answerIndex >= 0 && answerIndex < options.length ? options[answerIndex] : "";

            const is_correct = userOption === correctOption;

            return {
                order: 1,
                question: question,
                options: options.map((opt, i) => `${String.fromCharCode(97 + i)}) ${opt}`),
                answer: answer ? `${userOption}) ${answer}` : "",
                is_correct: is_correct
            };
        });

        // console.log("bu map bolgan",parsedTests);
        const questionsJson = JSON.stringify(parsedTests, null, 4);
        const sectionBTotal = sectionBScores[0]?.score;
        useEffect(() => {
            const timer = setTimeout(() => {
                if (sectionBTotal > 0) {
                    setQuizModal(true);
                    sectionBScores = [];
                } else {
                    setQuizModal(false);
                }
            }, 2000);

            return () => clearTimeout(timer);
        }, [sectionBTotal]);
        const studentId = sessionStorage.getItem("stId");
        // useEffect(() => {

        //     console.log("examData post", examData);
        //     axios.post(`https://iifabackend.diyoraai.uz/student/exam/results`, examData, {
        //         headers: {
        //             Authorization: `Bearer ${localStorage.getItem("token")}`,
        //         }
        //     })
        //         .then(response => {
        //             console.log('Success:', response.data);
        //         })
        //         .catch(error => {
        //             console.log('Error:', error);
        //         });
        // }, [])

        // console.log("examData", examData);



        const submitExamResults = () => {
            const examData = {
                student_id: studentId,
                learner_id: enrollmentId,
                chapter_id: chapterId,
                total_score: totalScore,
                passed: totalScore >= 60,
                test: {
                    overal: testScore,
                    feedback: feedbackMessages[0],
                    items: parsedTests.slice(0, 20)
                },
                section_b: {
                    overal: sectionBTotal,
                    feedback: "Section B uchun feedbeck berilmagan",
                    tasks: [
                        {
                            problem: sectionBMessages[1]?.text,
                            answer: sectionBAnswers[0],
                            score: sectionBTotal
                        }
                    ]
                },
                chapter_title: "",
                course_title: ""
            }

            console.log("examData post", examData);
            axios.post(`${API}/student/exam/results`, examData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            })
                .then(response => {
                    console.log('Success:', response.data);
                    toast.success("Results sent successfully");
                    setSectionBScores([]);
                    setSectionBAnswers([]);
                    setFeedbackMessages([]);
                    setMyAnswersList([]);
                    setQuizModal(false);
                    navigate(`/student/courses/${enrollmentId}`);
                })
                .catch(error => {
                    console.log('Error:', error);
                    toast.error("Error sending results");
                }).finally(() => {
                    setQuizModal(false);
                    setSectionBScores([]);
                    setSectionBAnswers([]);
                    setFeedbackMessages([]);
                    setMyAnswersList([]);
                    setTests([]);
                })
        }

        const [isReadyToStart, setIsReadyToStart] = useState(false);

        useEffect(() => {
            if (isConnectionOpen) {
                const timer = setTimeout(() => {
                    setIsReadyToStart(true);
                }, 2000);

                return () => clearTimeout(timer);
            } else {
                setIsReadyToStart(false);
            }
        }, [isConnectionOpen]);


        // console.log("daishfdhigbfsn", textOfVideo)

        return (
            <div className={`chat-container ${socket === "help" && messages.length === 0 ? "chatHeight" : ""}`} style={{ width: "100% !important" }}>
                <div className="chat-header">
                    <div className="robot-block">
                        {/* <img className="robotImg" src={Robot} alt="robot" /> */}
                        <div className="chat-name-block">
                            <h3 className="chat-name">
                                {/* <span className="blue-text">{t('chatName')}</span> */}
                            </h3>
                            {/* <p className="online-text">
                                {t('status')} {connectionStatus}
                                {!isConnectionOpen && (
                                    <button
                                        className="reconnect-button"
                                        onClick={reconnectWebSocket}
                                        disabled={readyState === ReadyState.CONNECTING}
                                    >
                                        {t('reconnect')}
                                    </button>
                                )}
                            </p> */}
                        </div>
                    </div>
                    {socket === "help" ? (
                        <h4 className="help-title">{t('helpTitle')}</h4>
                    ) : (<h4 className="help-title">{t('testTitle')}</h4>)}
                </div>
                <div className="chat-body" ref={chatBodyRef}>
                    <div className="date-container">
                        <p className="date">{formatDate()}</p>
                    </div>
                    {messages.map((msg, index) => {
                        const lastMessageIndex = messages.length - 1;
                        const isAudioAvailable = audioFiles.some(audio => audio.index === lastMessageIndex);

                        return msg?.visible ? (
                            <div key={index} className={`message ${msg.sender === "user" ? "user-message" : ""}`}>
                                {msg.sender === "user" ? (
                                    <TextRenderer text={msg.text} className="input-mes" />
                                ) : (
                                    <TextRenderer text={msg.text} className="message-bot">


                                        <div className="vois-play">
                                            {isAudioAvailable || index !== lastMessageIndex ? (
                                                socket === "help" && (
                                                    !playState[index]?.isPlayVois ? (
                                                        <i
                                                            className="ri-volume-up-fill"
                                                            onClick={() => playSavedAudio(index)}
                                                        ></i>
                                                    ) : (
                                                        <img className="play-gif" src={PlayAudio} />
                                                    )
                                                )
                                            ) : null}
                                        </div>
                                    </TextRenderer>

                                )}
                                <p className={`time ${msg.sender === "user" ? "time-user" : ""}`}>
                                    {msg.time}
                                </p>
                            </div>
                        ) : null
                    })}
                    {isTyping && (
                        <div className="message typing-indicator">
                            <p className="message-bot">{t('botTyping')}</p>
                        </div>
                    )}
                </div>
                <div className="chat-input">
                    {(isTestMode || isProblemsStarterMessage) ? (
                        socket === "nazorat_savol" ? (
                            <button
                                disabled={clicked || !isReadyToStart}
                                className="start-test-button"
                                onClick={handleStartTest}
                            >
                                {clicked ? t('starting') : t('sectionBStart')}
                            </button>
                        ) : (
                            <button
                                disabled={clicked || !isReadyToStart}
                                className="start-test-button"
                                onClick={handleStartTest}
                            >
                                {clicked ? t('starting') : t('startTest')}
                            </button>
                        )
                    ) : (
                        <>
                            {isSectionB ? (
                                <textarea
                                    rows={4}
                                    placeholder="Your message"
                                    value={input}
                                    onChange={(e) => {
                                        setInput(e.target.value);
                                    }}
                                    onKeyDown={(e) => e.key === "Enter" && handleSend()}
                                    disabled={!isConnectionOpen}
                                />
                            ) : (
                                socket === "nazorat_test" ? (
                                    <input
                                        type="text"
                                        placeholder="Your message"
                                        ref={inputRef}
                                        value={input}
                                        onChange={(e) => {
                                            if (isConnectionOpen) {
                                                const rawValue = e.target.value;
                                                const allowedCharsRegex = /^[abcdабвгсд]*$/i;
                                                // Faqat allowed bo'lganlarini qabul qilish
                                                if (allowedCharsRegex.test(rawValue) && rawValue.length <= 1) {
                                                    setInput(rawValue);
                                                }
                                            }
                                        }}

                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" && !isTyping) {
                                                handleSend();
                                            }
                                        }}
                                        onBlur={() => setIsTyping(false)}
                                    />
                                ) : (
                                    <input
                                        type="text"
                                        placeholder="Your message"
                                        value={input}
                                        onChange={(e) => {
                                            setInput(e.target.value)

                                        }}
                                        onKeyDown={(e) => e.key === "Enter" && handleSend()}
                                        disabled={!isConnectionOpen}
                                    />
                                )
                            )}
                            {socket === "help" && (
                                !isRecording ? (
                                    <button onClick={startRecording} className="bot-microphone">{t('voisBtn')}</button>
                                ) : (<button onClick={handleStopAndSend}
                                    className="stop-recording button record-border">Остановить запись</button>)
                            )}
                            <button
                                className="send-button"
                                onClick={handleSend}
                                disabled={isTyping}
                            >
                                <span className="sendText">{t('sendBtn')}</span>
                            </button>
                        </>
                    )}
                </div>
                {quizModal && (<QuizModal score={totalScore} submitFunc={submitExamResults} />)}
                {questionsBot && (
                    <Warning />
                )}

            </div>
        );
    };

export default Chat;

